// SubscriptionRequiredPage — Phase 16 Gate 2 — landing for 402 responses.

import { Link } from "react-router-dom";
import { Lock, MessageSquare } from "lucide-react";

export default function SubscriptionRequiredPage() {
    return (
        <div data-testid="subscription-required-page">
            <section className="section" style={{ paddingTop: 96 }}>
                <div className="section__inner" style={{ maxWidth: 720, textAlign: "center" }}>
                    <div className="cap-card__icon" style={{ margin: "0 auto 24px", width: 56, height: 56, borderRadius: "50%" }}>
                        <Lock size={26} />
                    </div>
                    <span className="section__eyebrow">// 402</span>
                    <h1 className="section__heading">Subscription required</h1>
                    <p className="section__lede" style={{ margin: "0 auto 32px" }}>
                        Your tenant doesn't currently have an active enterprise subscription, or
                        the existing subscription has expired. To restore access, contact your
                        UAVSimNet representative — they can renew or upgrade your subscription
                        manually.
                    </p>
                    <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                        <Link to="/contact" className="btn-primary" data-testid="subscription-required-contact">
                            <MessageSquare size={16} />
                            Contact us
                        </Link>
                        <Link to="/" className="btn-secondary" data-testid="subscription-required-home">
                            Return home
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
